import React, { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../Router/all_routes";
import { ShoppingCart } from "feather-icons-react/build/IconComponents";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import {
  deleteSales,
  getSalesByTransType,
} from "../../services/SalesApiServices";
import SalesInvoiceModal from "../../components/transactions/modal/SalesInvoiceModal";
import { useDispatch, useSelector } from "react-redux";
import { InvSales } from "../../core/json/invSales";
import {
  fetchCustomer,
  fetchProduct,
  fetchSettings,
} from "../../redux/userSetting";
import { fetchUserByBranch } from "../../redux/userServices";
import { fetchBranchSettings } from "../../redux/settingbyBranch";
import { getWareHouseList } from "../../services/MasterApiServices";
import {
  TransactionScreen,
  SALES_PAYMENTS,
  isPosBill,
} from "../../components/transactions/list";
import { dateOf, dmy, intg, money, num } from "../../components/report/reportFormat";

const SalesInvoice = () => {
  const routes = all_routes;
  const [salesData, setsalesData] = useState([]);
  const [updateData, setUpdateData] = useState([]);
  const [modalMode, setModalMode] = useState("add");
  const [modalOpen, setModalOpen] = useState(false);
  const [wareHouseList, setWareHouseList] = useState([]);
  const { branch } = useSelector((state) => state.branchlist);
  const { userId } = useSelector((state) => state.userauth);
  const { customerList } = useSelector((state) => state.usersetting);
  const { UserListByBranch } = useSelector((state) => state.userservice);
  const MySwal = withReactContent(Swal);
  const { menuItems } = useSelector((state) => state.amc);
  const [permit, setpermit] = useState();
  const dispatch = useDispatch();

  useEffect(() => {
    setpermit(
      menuItems?.menuPermissions?.find((e) => e.menu.name == "Sales Invoice")
    );
  }, []);
  useEffect(() => {
    dispatch(fetchProduct(branch));
    dispatch(fetchCustomer(branch));
    dispatch(fetchSettings(branch));
    dispatch(fetchBranchSettings(branch.guid));
    dispatch(fetchUserByBranch(branch));
    handlesalesData();
  }, [branch]);

  useEffect(() => {
    const fetchWarehouses = async () => {
      try {
        const response = await getWareHouseList();
        setWareHouseList(Array.isArray(response) ? response : []);
      } catch (err) {
        console.error("Failed to fetch warehouses:", err);
      }
    };
    fetchWarehouses();
  }, []);

  const handlesalesData = async () => {
    try {
      const response = await getSalesByTransType(branch, 2);
      setsalesData(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error(
        "Failed to fetch sales invoices",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };

  const handleEditClick = async (guid) => {
    try {
      const response = getsalesInvoiceByGuid(guid);
      setUpdateData(response);
      setModalMode("edit");
      setModalOpen(true);
    } catch (error) {
      console.error(
        "Error fetching sales invoice by GUID",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };

  function getsalesInvoiceByGuid(guid) {
    const filteredsales = salesData?.filter((sales) => sales.guid === guid);
    return filteredsales[0];
  }
  const handleDeleteClick = (obj) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      cancelButtonColor: "#ff0000",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const objsales = new InvSales();
          objsales.id = obj.id;
          objsales.guid = obj.guid;
          objsales.branch = branch;
          objsales.isDeleted = true;
          objsales.updatedUser = `{${userId?.id}}`;
          objsales.currency = "00000000-0000-0000-0000-000000000000";

          const response = await deleteSales(objsales);
          if (response === true) {
            MySwal.fire({
              title: "Deleted!",
              text: "The sales invoice has been deleted.",
              icon: "success",
              confirmButtonColor: "#00ff00",
              confirmButtonText: "OK",
            }).then(() => {
              handlesalesData();
            });
          } else {
            MySwal.fire({
              title: "Error!",
              text: "something went wrong",
              icon: "error",
              confirmButtonColor: "#ff0000",
              confirmButtonText: "OK",
            });
          }
        } catch (error) {
          console.error(
            "Error deleting reason:",
            error?.response?.data?.Message || "something went wrong"
          );
          MySwal.fire({
            title: "Error!",
            text: error?.response?.data?.Message || "something went wrong",
            icon: "error",
            confirmButtonColor: "#ff0000",
            confirmButtonText: "OK",
          });
        }
      }
    });
  };

  /* ---------------- list ---------------- */
  const warehouseMap = useMemo(
    () => Object.fromEntries(wareHouseList.map((w) => [w.guid, w.name || "Unnamed Warehouse"])),
    [wareHouseList]
  );
  const userMap = useMemo(
    () => Object.fromEntries((UserListByBranch || []).map((u) => [u.guid, u.name])),
    [UserListByBranch]
  );

  // one flat record per invoice; the keys match the column definitions
  const rows = useMemo(
    () =>
      salesData.map((inv) => {
        const sm = inv.salesman;
        const salesmanGuid = sm && typeof sm === "object" ? sm.guid : sm || "";
        const salesman = (sm && typeof sm === "object" && sm.name) || userMap[salesmanGuid] || "";
        const pay = SALES_PAYMENTS.find((p) => p.v === inv.salesPaymentType);
        return {
          guid: inv.guid,
          raw: inv,
          date: dateOf(inv.invdate),
          billNo: inv.entrynumber || "",
          isPos: isPosBill(inv.entrynumber),
          customer: inv.customer?.name || inv.customerName || "Unknown Customer",
          customerGuid: inv.customer?.guid,
          refNo: inv.refNo || "",
          warehouse: warehouseMap[inv.location?.guid] || inv.location?.name || "",
          warehouseGuid: inv.location?.guid,
          salesman,
          salesmanGuid,
          payment: pay?.t || "Unknown",
          paymentType: inv.salesPaymentType,
          deliveryDate: dateOf(inv.deliveryDate),
          items: (inv.invSalesDetails || []).length,
          total: num(inv.grossTotal),
          additional: num(inv.additionalAmt),
          discount: num(inv.discountTotal),
          roundOff: num(inv.roundOff),
          tax: num(inv.taxTotal),
          net: num(inv.netTotal),
          lines: inv.invSalesDetails || [],
        };
      }),
    [salesData, warehouseMap, userMap]
  );

  const columns = useMemo(
    () => [
      { k: "date", t: "Date", type: "date", ago: true },
      {
        k: "billNo",
        t: "Invoice",
        type: "doc",
        badge: (r) => (r.isPos ? { text: "POS", tone: "pos" } : { text: "SI" }),
      },
      { k: "customer", t: "Customer", type: "party", sub: (r) => r.salesman },
      { k: "refNo", t: "Reference No" },
      {
        k: "payment",
        t: "Type",
        type: "chip",
        chip: (r) => ({ text: r.payment, tone: SALES_PAYMENTS.find((p) => p.v === r.paymentType)?.tone }),
      },
      { k: "warehouse", t: "Warehouse", off: true },
      { k: "salesman", t: "Salesman", off: true },
      { k: "items", t: "Items", type: "int", off: true },
      { k: "deliveryDate", t: "Delivery Date", type: "date" },
      { k: "total", t: "Gross", type: "money", off: true },
      { k: "discount", t: "Discount", type: "money", off: true },
      { k: "tax", t: "Tax", type: "money", off: true },
      { k: "net", t: "Net Amount", type: "money" },
    ],
    []
  );

  const tabs = useMemo(
    () => [
      { id: "all", label: "Sales Invoice" },
      { id: "pos", label: "POS", match: (r) => r.isPos },
    ],
    []
  );

  const filters = useMemo(
    () => [
      {
        key: "customers",
        label: "Customer",
        items: (customerList || []).map((c) => ({ v: c.guid, t: c.name || "—" })),
        match: (r, v) => v.includes(r.customerGuid),
      },
      {
        key: "warehouses",
        label: "Warehouse",
        items: wareHouseList.map((w) => ({ v: w.guid, t: w.name || "Unnamed Warehouse" })),
        match: (r, v) => v.includes(r.warehouseGuid),
      },
      {
        key: "salesmen",
        label: "Salesman",
        items: (UserListByBranch || []).map((u) => ({ v: u.guid, t: u.name || "—" })),
        match: (r, v) => v.includes(r.salesmanGuid),
      },
      {
        key: "payments",
        label: "Payment type",
        items: SALES_PAYMENTS.map((p) => ({ v: p.v, t: p.t })),
        match: (r, v) => v.includes(r.paymentType),
      },
    ],
    [customerList, wareHouseList, UserListByBranch]
  );

  const searchMatch = (r, q) => {
    const hit = (s) => String(s || "").toLowerCase().includes(q);
    return (
      hit(r.billNo) ||
      hit(r.customer) ||
      hit(r.refNo) ||
      hit(r.salesman) ||
      hit(r.date) ||
      String(r.net).includes(q) ||
      r.lines.some((l) => hit(l?.product?.name) || hit(l?.product?.code))
    );
  };

  const drawerContent = (r) => ({
    title: r.customer,
    subtitle: [r.billNo, dmy(r.date), r.refNo].filter(Boolean).join("  ·  "),
    avatarKey: r.customer,
    meta: [
      { k: "Warehouse", v: r.warehouse },
      { k: "Salesman", v: r.salesman },
      { k: "Type", v: r.payment },
      { k: "Delivery date", v: r.deliveryDate ? dmy(r.deliveryDate) : "" },
      { k: "Items", v: intg(r.items) },
      { k: "Source", v: r.isPos ? "POS" : "Sales invoice" },
    ],
    lines: {
      title: "Invoice lines",
      columns: [
        { t: "Item" },
        { t: "Qty", align: "right" },
        { t: "Rate", align: "right" },
        { t: "Disc", align: "right" },
        { t: "Amount", align: "right" },
      ],
      rows: r.lines.map((l) => [
        <>
          <div className="axr-nm">{l?.product?.name || "Unknown Item"}</div>
          <div className="axr-cd">{[l?.product?.code, l?.unit?.name].filter(Boolean).join(" · ")}</div>
        </>,
        intg(l?.quantity),
        money(l?.price),
        num(l?.discAmt) ? money(l.discAmt) : "—",
        money(l?.netAmt),
      ]),
    },
    totals: [
      { l: "Gross", v: money(r.total) },
      { l: "Discount", v: r.discount ? "−" + money(r.discount) : "0.00" },
      { l: "Additional", v: money(r.additional) },
      { l: "VAT", v: money(r.tax) },
      { l: "Round off", v: money(r.roundOff) },
    ],
    net: { l: "Net amount", v: money(r.net) },
  });

  return (
    <TransactionScreen
      title="Sales Invoice"
      subtitle="Manage sales here"
      unit="invoices"
      rows={rows}
      columns={columns}
      tabs={tabs}
      filters={filters}
      searchMatch={searchMatch}
      searchPlaceholder="Invoice no, customer, reference, item, amount…"
      sortOptions={[
        { v: "date:-1", t: "Newest first" },
        { v: "date:1", t: "Oldest first" },
        { v: "net:-1", t: "Largest amount" },
        { v: "net:1", t: "Smallest amount" },
        { v: "customer:1", t: "Customer A–Z" },
      ]}
      exportName="Sales invoice"
      onRefresh={handlesalesData}
      canAdd={permit?.add}
      newLabel="New invoice"
      onNew={() => {
        setModalMode("add");
        setModalOpen(true);
      }}
      headerActions={
        // the till writes the same invoice this screen does, so it sits
        // behind the same add permission
        <Link to={routes.POS} className="axr-btn axt-btn-pos">
          <ShoppingCart />
          POS Billing
        </Link>
      }
      canEdit={permit?.edit}
      onEdit={(r) => handleEditClick(r.guid)}
      editLabel="Edit invoice"
      canDelete={permit?.deletion}
      onDelete={(r) => handleDeleteClick(r.raw)}
      drawerContent={drawerContent}
      keysDisabled={modalOpen}
    >
      {modalOpen && (
        <SalesInvoiceModal
          mode={modalMode}
          data={modalMode === "edit" ? updateData : {}}
          handleClose={() => setModalOpen(false)}
          handleRefresh={() => {
            handlesalesData();
          }}
          modalOpen={modalOpen}
        />
      )}
    </TransactionScreen>
  );
};

export default SalesInvoice;
